export type LoyaltyLocale = 'ru' | 'kk';

const RU = {
  'tab.rules': 'Правила',
  'tab.account': 'Клиент',
  'tab.tiers': 'Уровни',
  'tab.reconciliation': 'Сверка',
  'tab.guards': 'Ограничения',
  'tab.suggestions': 'Подсказки оператору',
  'suggest.title': 'Что предложить клиенту',
  'suggest.hint':
    'Подсказки видит оператор на карточке клиента у въезда. Каждого типа — не больше одной, по приоритету: меньше число — важнее.',
  'suggest.kind': 'Тип',
  'suggest.kind.next_service': 'Следующая услуга',
  'suggest.kind.upgrade': 'Апгрейд',
  'suggest.kind.subscription': 'Подписка',
  'suggest.titleField': 'Текст для оператора',
  'suggest.titleHint': 'Коротко, как оператор скажет клиенту: «Химчистка салона со скидкой»',
  'suggest.targetService': 'Код услуги',
  'suggest.targetPlan': 'Код тарифного плана',
  'suggest.fromServices': 'Если последний заказ содержит (коды через запятую)',
  'suggest.minDays': 'Не чаще, чем раз в дней',
  'suggest.minVisits': 'Не меньше визитов',
  'suggest.windowDays': 'За дней',
  'suggest.segments': 'Сегменты (коды через запятую)',
  'suggest.priority': 'Приоритет',
  'suggest.add': 'Добавить подсказку',
  'suggest.saved': 'Подсказка сохранена',
  'suggest.pause': 'Приостановить',
  'suggest.resume': 'Включить',
  'suggest.active': 'Действует',
  'suggest.paused': 'Приостановлена',
  'suggest.empty': 'Подсказок пока нет — оператор видит только правила начисления бонусов',
  'suggest.readonly': 'Правка подсказок доступна маркетологу и администратору сети.',
  'suggest.target': 'Цель',
  'suggest.conditions': 'Условия',
  'guards.title': 'Ограничения начисления',
  'guards.hint':
    'Пределы применяет движок при каждом начислении.',
  'guards.site': 'Где действует',
  'guards.siteHint': 'Настройка объекта перекрывает сетевую целиком, а не по отдельным полям',
  'guards.network': 'Вся сеть',
  'guards.loading': 'Загружаем настройку…',
  'guards.inherited': 'Своей настройки у объекта нет',
  'guards.inheritedHint':
    'Показана сетевая. Сохранение создаст настройку объекта — с этого момента сетевая на нём действовать перестанет.',
  'guards.perVisit': 'Начислений за визит',
  'guards.perVisitHint': 'Ноль — без предела',
  'guards.perPeriod': 'Начислений за период',
  'guards.perPeriodHint': 'Ноль — без предела',
  'guards.periodDays': 'Длина периода, дней',
  'guards.periodDaysHint': 'Скользящее окно, считается назад от момента начисления',
  'guards.amount': 'Сумма начислений за период',
  'guards.amountHint': 'Ноль — без предела',
  'guards.requireVehicle': 'Начислять только при привязанном автомобиле',
  'guards.requireVehicleHint':
    'Отсекает начисления по визитам, где клиента определили, а машину к нему не привязали',
  'guards.blockSelfReferral': 'Запрещать самореферал',
  'guards.blockSelfReferralHint':
    'Действует только для реферальных начислений. Реферальной программы пока нет, поэтому флажок сейчас ни на что не влияет',
  'guards.summary':
    'Сейчас: не более {visit} начислений на визит и {period} за {days} дней.',
  'guards.unlimited': 'без предела',
  'guards.save': 'Сохранить',
  'guards.saved': 'Ограничения сохранены',
  'guards.readonly': 'Правка ограничений доступна маркетологу и администратору сети.',

  'apps.title': 'Решения по начислениям',
  'apps.hint':
    'Почему начислено или почему нет: движок пишет решение по каждому оплаченному заказу.',
  'apps.when': 'Когда',
  'apps.outcome': 'Решение',
  'apps.reason': 'Основание',
  'apps.amount': 'Сумма',
  'apps.rule': 'Правило',
  'apps.order': 'Заказ',
  'apps.empty': 'Решений пока нет',
  'apps.emptyHint':
    'Движок ещё не оценивал заказы этого клиента: либо оплаченных заказов нет, либо они прошли до появления правил.',
  'rules.title': 'Конструктор правил начисления',
  'rules.create': 'Новое правило',
  'rules.empty': 'Правил пока нет',
  'rules.code': 'Код',
  'rules.name': 'Название',
  'rules.version': 'Версия',
  'rules.status': 'Статус',
  'rules.priority': 'Приоритет',
  'rules.priority.hint':
    'На заказ начисляется одно правило «процент» или «сумма» — с наименьшим числом. При равных числах выигрывает код, который раньше по алфавиту. Множители добавляются сверху. Чтобы новое правило перекрыло базовое, дайте ему число меньше.',
  'rules.sites': 'Объекты',
  'rules.sites.all': 'Ничего не выбрано — правило работает по всей сети',
  'rules.status.draft': 'Черновик',
  'rules.status.active': 'Опубликовано',
  'rules.status.archived': 'В архиве',
  'rules.publish': 'Опубликовать',
  'rules.publishConfirm': 'Опубликовать правило {code}?',
  'rules.publishEffect': 'Правило начнёт применяться ко всем новым оплаченным заказам сети',
  'rules.publishPreview':
    'Предпросмотр: заказов затронуто {orders}, клиентов {customers}, начислено бы {delta}',
  'rules.publishNoPreview': 'Предпросмотр не выполнялся — последствия не оценены',
  'rules.published': 'Правило {code} опубликовано',
  'rules.archive': 'Снять с публикации',
  'rules.restore': 'Вернуть публикацию',
  'rules.restoreConfirm': 'Вернуть публикацию правилу {code} v{version}?',
  'rules.restoreEffect': 'Правило снова начнёт применяться ко всем новым оплаченным заказам сети',
  'rules.restoreSupersedes':
    'Действующая версия v{version} уйдёт в архив: на один код действует одно правило',
  'rules.restoreNoActive': 'Действующей версии по этому коду сейчас нет',
  'rules.restored': 'Публикация правила {code} возвращена',
  'rules.save': 'Сохранить черновик',
  'rules.condition': 'Условие',
  'rules.action': 'Действие',
  'rules.condition.services': 'Услуги',
  'rules.condition.services.all': 'Ничего не выбрано — любая услуга',
  'rules.condition.minAmount': 'Сумма заказа от, ₸',
  'rules.condition.maxAmount': 'Сумма заказа до, ₸',
  'rules.condition.segments': 'Сегменты',
  'rules.condition.segments.all': 'Ничего не выбрано — любой клиент',
  'rules.condition.days': 'Дни недели',
  'rules.condition.timeFrom': 'Время с',
  'rules.condition.timeTo': 'Время по',
  'rules.condition.visitFrom': 'Номер визита от',
  'rules.condition.visitTo': 'Номер визита до',
  'rules.action.kind': 'Тип начисления',
  'rules.action.fixed': 'Фиксированная сумма',
  'rules.action.percent': 'Процент от заказа',
  'rules.action.multiplier': 'Множитель к начислению',
  'rules.action.amount': 'Сумма, ₸',
  'rules.action.percentValue': 'Процент',
  'rules.action.factor': 'Множитель',
  'rules.action.expires': 'Срок действия бонуса, дней',
  'tab.referrals': 'Приглашения',
  'rules.action.burn': 'Оплата бонусами (правило списания)',
  'rules.action.burnShare': 'Какую долю чека можно оплатить бонусами, %',
  'rules.action.burnRate': 'Сколько тенге стоит 1 бонус',
  'rules.action.burnMin': 'Тратить бонусы, когда на счёте не меньше',
  'rules.action.burnHint':
    'Правило списания не начисляет бонусы — оно разрешает кассе принять ими оплату. Действует первое по приоритету правило, подходящее по условию; без такого правила касса бонусы не принимает.',
  'rules.action.describeBurn': 'Касса примет бонусами до {share} % чека, 1 бонус = {rate} ₸',
  'ref.policy.title': 'Условия реферальной программы',
  'ref.policy.hint':
    'Бонус приходит сам, когда приглашённый оплатит первый визит на сумму не ниже порога. Самореферал и давние клиенты отклоняются.',
  'ref.policy.enabled': 'Программа включена',
  'ref.policy.referrer': 'Бонус пригласившему',
  'ref.policy.invitee': 'Приветственный бонус приглашённому',
  'ref.policy.minOrder': 'Первый заказ не меньше',
  'ref.policy.expires': 'Срок действия бонусов, дней',
  'ref.policy.expiresHint': 'Пусто — бессрочно',
  'ref.policy.save': 'Сохранить условия',
  'ref.policy.saved': 'Условия сохранены',
  'ref.policy.readonly': 'Условия меняет маркетолог',
  'ref.list.title': 'Кто кого пригласил',
  'ref.list.hint':
    'Канал — откуда пришёл код: касса, планшет, админка, ссылка или перенос из прежней системы.',
  'ref.list.allSources': 'Все каналы',
  'ref.list.date': 'Когда',
  'ref.list.referrer': 'Пригласил',
  'ref.list.invitee': 'Приглашённый',
  'ref.list.source': 'Канал',
  'ref.list.status': 'Статус',
  'ref.list.reward': 'Бонус',
  'ref.list.empty': 'Приглашений пока нет',
  'ref.list.emptyHint':
    'Код приглашения есть у каждого клиента — его видно в карточке клиента на вкладке «Клиент».',
  'ref.source.pos': 'Касса',
  'ref.source.tablet': 'Планшет',
  'ref.source.admin': 'Админка',
  'ref.source.link': 'Ссылка',
  'ref.source.import': 'Перенос',
  'ref.status.pending': 'Ждёт первого визита',
  'ref.status.rewarded': 'Бонус начислен',
  'ref.status.rejected': 'Отклонено',
  'ref.card.title': 'Приглашения',
  'ref.card.code': 'Код приглашения клиента',
  'ref.card.invitedBy': 'Пригласил',
  'ref.card.none': 'Пригласивший не указан',
  'ref.card.stats': 'Пригласил клиентов: {count}, из них с бонусом: {rewarded}, получено {amount}',
  'ref.card.attachCode': 'Код пригласившего',
  'ref.card.attach': 'Записать пригласившего',
  'ref.card.attached': 'Пригласивший записан',
  'rules.preview': 'Предпросмотр',
  'rules.preview.from': 'С',
  'rules.preview.to': 'По',
  'rules.preview.run': 'Посчитать',
  'rules.preview.hint': 'Прогон на прошлом периоде. В реестр ничего не пишется.',
  'rules.preview.orders': 'Заказов затронуто',
  'rules.preview.customers': 'Клиентов затронуто',
  'rules.preview.delta': 'Начислили бы дополнительно',
  'rules.preview.scanned': 'Заказов просмотрено',
  'rules.preview.truncated': 'Показана часть периода: слишком много заказов',
  'rules.history': 'Журнал изменений',
  'rules.versions': 'Версии правила',
  'account.title': 'Счёт клиента',
  'account.search': 'Клиент',
  'account.searchHint': 'Найдите по телефону или номеру автомобиля',
  'account.none': 'Бонусного счёта пока нет',
  'account.noneHint':
    'Счёт заводится первым начислением. Начислить вручную можно после первого оплаченного заказа клиента.',
  'account.load': 'Открыть',
  'account.reload': 'Обновить',
  'account.ledgerBalance': 'Баланс по реестру',
  'account.materialized': 'Материализованное значение',
  'account.drift': 'Расхождение',
  'account.entries': 'Реестр операций',
  'account.direction': 'Направление',
  'account.amount': 'Сумма',
  'account.reason': 'Основание',
  'account.rule': 'Правило',
  'account.date': 'Дата',
  'account.credit': 'Начисление',
  'account.debit': 'Списание',
  'account.more': 'Показать ещё',
  'adjust.title': 'Ручная корректировка',
  'adjust.reason': 'Основание',
  'adjust.comment': 'Комментарий',
  'adjust.submit': 'Провести',
  'adjust.done': 'Корректировка проведена',
  'module.subtitle': 'Правила начисления, счета клиентов, уровни и сверка реестра',
  'tiers.title': 'Уровни программы',
  'tiers.code': 'Код',
  'tiers.name': 'Название',
  'tiers.condition': 'Условие входа',
  'tiers.order': 'Порядок',
  'tiers.recalculate': 'Пересчитать уровни',
  'tiers.recalculated': 'Проверено клиентов: {checked}, переходов: {changed}',
  'tiers.empty': 'Уровни не заведены',
  'tiers.emptyReason':
    'Заведите первый уровень в форме ниже: код, название и условие входа. Пересчёт разложит клиентов по уровням.',
  'tiers.hint': 'Порядок задаёт старшинство: чем больше число, тем выше уровень.',
  'tiers.newTitle': 'Новый уровень',
  'tiers.editTitle': 'Правка уровня {code}',
  'tiers.edit': 'Править',
  'tiers.create': 'Завести уровень',
  'tiers.save': 'Сохранить уровень',
  'tiers.created': 'Уровень заведён',
  'tiers.updated': 'Уровень обновлён',
  'tiers.codeHint': 'Латиницей, например silver или gold. Код нельзя изменить после создания.',
  'tiers.orderHint': 'Больше — выше уровень',
  'tiers.conditionTitle': 'Условие входа',
  'tiers.conditionHint':
    'Достаточно одного условия. Если задан период, условие считается за последние N дней; без периода — за всё время.',
  'tiers.conditionRequired': 'Задайте хотя бы одно условие входа, иначе уровень никому не достанется',
  'tiers.minAccrued': 'Начислено бонусов, не меньше',
  'tiers.minSpend': 'Оплачено, не меньше',
  'tiers.minVisits': 'Визитов, не меньше',
  'tiers.periodDays': 'Период, дней',
  'tiers.periodHint': 'Пусто — за всё время',
  'tiers.cond.accrued': 'начислено от {value}',
  'tiers.cond.spend': 'оплачено от {value}',
  'tiers.cond.visits': 'визитов от {value}',
  'tiers.cond.window': 'за {days} дней',
  'tiers.cond.lifetime': 'за всё время',
  'tiers.cond.none': 'условие не задано',
  'recon.title': 'Отчёт по расхождениям',
  'recon.run': 'Запустить сверку',
  'recon.empty': 'Расхождений нет',
  'recon.incident': 'Непустой отчёт — это инцидент',
  'recon.checked': 'Счетов проверено',
  'recon.findings': 'Расхождений',
  'recon.customer': 'Клиент',
  'recon.materialized': 'Было',
  'recon.ledger': 'Реестр',
  'recon.delta': 'Разница',
  'recon.repaired': 'Исправлено',
  'recon.never': 'Сверка ещё не запускалась',
  'common.loading': 'Загрузка…',
  'common.cancel': 'Отмена',
  'common.yes': 'Да',
  'common.no': 'Нет',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'tab.rules': 'Ережелер',
  'tab.account': 'Клиент',
  'tab.tiers': 'Деңгейлер',
  'tab.reconciliation': 'Салыстыру',
  'tab.guards': 'Шектеулер',
  'tab.suggestions': 'Операторға кеңестер',
  'suggest.title': 'Клиентке не ұсыну керек',
  'suggest.hint':
    'Кеңестерді оператор кіреберістегі клиент карточкасынан көреді. Әр түрден біреуден артық емес, басымдық бойынша: сан кіші болса — маңыздырақ.',
  'suggest.kind': 'Түрі',
  'suggest.kind.next_service': 'Келесі қызмет',
  'suggest.kind.upgrade': 'Жақсарту',
  'suggest.kind.subscription': 'Жазылым',
  'suggest.titleField': 'Операторға арналған мәтін',
  'suggest.titleHint': 'Қысқа, оператор клиентке қалай айтса солай',
  'suggest.targetService': 'Қызмет коды',
  'suggest.targetPlan': 'Тариф жоспарының коды',
  'suggest.fromServices': 'Соңғы тапсырыста болса (кодтар үтір арқылы)',
  'suggest.minDays': 'Күннен жиі емес',
  'suggest.minVisits': 'Кемінде барулар',
  'suggest.windowDays': 'Күн ішінде',
  'suggest.segments': 'Сегменттер (кодтар үтір арқылы)',
  'suggest.priority': 'Басымдық',
  'suggest.add': 'Кеңес қосу',
  'suggest.saved': 'Кеңес сақталды',
  'suggest.pause': 'Тоқтата тұру',
  'suggest.resume': 'Қосу',
  'suggest.active': 'Әрекет етеді',
  'suggest.paused': 'Тоқтатылған',
  'suggest.empty': 'Кеңестер әзірге жоқ — оператор тек бонус есептеу ережелерін көреді',
  'suggest.readonly': 'Кеңестерді өзгерту маркетолог пен желі әкімшісіне қолжетімді.',
  'suggest.target': 'Мақсат',
  'suggest.conditions': 'Шарттар',
  'guards.title': 'Есептеу шектеулері',
  'guards.hint':
    'Шектеулерді қозғалтқыш әр есептеуде қолданады.',
  'guards.site': 'Қайда қолданылады',
  'guards.siteHint': 'Нысан баптауы желілік баптауды толығымен алмастырады',
  'guards.network': 'Бүкіл желі',
  'guards.loading': 'Баптауды жүктеп жатырмыз…',
  'guards.inherited': 'Нысанның өз баптауы жоқ',
  'guards.inheritedHint':
    'Желілік баптау көрсетілген. Сақтау нысан баптауын жасайды — содан кейін желілік онда әрекет етпейді.',
  'guards.perVisit': 'Бір баруға есептеу саны',
  'guards.perVisitHint': 'Нөл — шектеусіз',
  'guards.perPeriod': 'Кезеңдегі есептеу саны',
  'guards.perPeriodHint': 'Нөл — шектеусіз',
  'guards.periodDays': 'Кезең ұзақтығы, күн',
  'guards.periodDaysHint': 'Есептеу сәтінен кері саналатын жылжымалы терезе',
  'guards.amount': 'Кезеңдегі есептеу сомасы',
  'guards.amountHint': 'Нөл — шектеусіз',
  'guards.requireVehicle': 'Тек көлік байланған кезде есептеу',
  'guards.requireVehicleHint':
    'Клиент анықталған, бірақ көлік байланбаған барулар бойынша есептеуді кеседі',
  'guards.blockSelfReferral': 'Өзін-өзі шақыруға тыйым салу',
  'guards.blockSelfReferralHint':
    'Тек реферал есептеулеріне қолданылады. Реферал бағдарламасы әлі жоқ, сондықтан белгі қазір ештеңеге әсер етпейді',
  'guards.summary':
    'Қазір: бір баруға {visit} және {days} күнде {period} есептеуден аспайды.',
  'guards.unlimited': 'шектеусіз',
  'guards.save': 'Сақтау',
  'guards.saved': 'Шектеулер сақталды',
  'guards.readonly': 'Шектеулерді өзгерту маркетолог пен желі әкімшісіне қолжетімді.',

  'apps.title': 'Есептеу шешімдері',
  'apps.hint':
    'Неге есептелді немесе неге жоқ: қозғалтқыш әр төленген тапсырыс бойынша шешімін жазады.',
  'apps.when': 'Қашан',
  'apps.outcome': 'Шешім',
  'apps.reason': 'Негіз',
  'apps.amount': 'Сома',
  'apps.rule': 'Ереже',
  'apps.order': 'Тапсырыс',
  'apps.empty': 'Әзірге шешімдер жоқ',
  'apps.emptyHint':
    'Қозғалтқыш бұл клиенттің тапсырыстарын әлі бағаламаған: не төленген тапсырыс жоқ, не олар ережелер пайда болғанға дейін өткен.',
  'rules.title': 'Есептеу ережелерінің конструкторы',
  'rules.create': 'Жаңа ереже',
  'rules.empty': 'Әзірге ережелер жоқ',
  'rules.code': 'Коды',
  'rules.name': 'Атауы',
  'rules.version': 'Нұсқа',
  'rules.status': 'Күйі',
  'rules.priority': 'Басымдық',
  'rules.priority.hint':
    'Тапсырысқа ең кіші саны бар бір «пайыз» немесе «сома» ережесі есептеледі. Сандар тең болса, әліпби бойынша ерте тұрған код ұтады. Көбейткіштер үстінен қосылады. Жаңа ереже негізгісін ығыстыруы үшін оған кішірек сан беріңіз.',
  'rules.sites': 'Нысандар',
  'rules.sites.all': 'Ештеңе таңдалмаған — ереже бүкіл желіде жұмыс істейді',
  'rules.status.draft': 'Жоба',
  'rules.status.active': 'Жарияланған',
  'rules.status.archived': 'Мұрағатта',
  'rules.publish': 'Жариялау',
  'rules.publishConfirm': '{code} ережесін жариялау керек пе?',
  'rules.publishEffect': 'Ереже желінің барлық жаңа төленген тапсырыстарына қолданыла бастайды',
  'rules.publishPreview':
    'Алдын ала қарау: тапсырыс {orders}, клиент {customers}, есептелер еді {delta}',
  'rules.publishNoPreview': 'Алдын ала қарау жасалмады — салдары бағаланбаған',
  'rules.published': '{code} ережесі жарияланды',
  'rules.archive': 'Жариялаудан алу',
  'rules.restore': 'Жарияланымды қайтару',
  'rules.restoreConfirm': '{code} v{version} ережесінің жарияланымы қайтарылсын ба?',
  'rules.restoreEffect': 'Ереже желінің барлық жаңа төленген тапсырыстарына қайта қолданылады',
  'rules.restoreSupersedes':
    'Қолданыстағы v{version} нұсқасы мұрағатқа кетеді: бір кодқа бір ереже әрекет етеді',
  'rules.restoreNoActive': 'Бұл код бойынша қолданыстағы нұсқа қазір жоқ',
  'rules.restored': '{code} ережесінің жарияланымы қайтарылды',
  'rules.save': 'Жобаны сақтау',
  'rules.condition': 'Шарт',
  'rules.action': 'Әрекет',
  'rules.condition.services': 'Қызметтер',
  'rules.condition.services.all': 'Ештеңе таңдалмаған — кез келген қызмет',
  'rules.condition.minAmount': 'Тапсырыс сомасы, бастап, ₸',
  'rules.condition.maxAmount': 'Тапсырыс сомасы, дейін, ₸',
  'rules.condition.segments': 'Сегменттер',
  'rules.condition.segments.all': 'Ештеңе таңдалмаған — кез келген клиент',
  'rules.condition.days': 'Апта күндері',
  'rules.condition.timeFrom': 'Уақыт, бастап',
  'rules.condition.timeTo': 'Уақыт, дейін',
  'rules.condition.visitFrom': 'Келу нөмірі, бастап',
  'rules.condition.visitTo': 'Келу нөмірі, дейін',
  'rules.action.kind': 'Есептеу түрі',
  'rules.action.fixed': 'Тіркелген сома',
  'rules.action.percent': 'Тапсырыстан пайыз',
  'rules.action.multiplier': 'Есептеуге көбейткіш',
  'rules.action.amount': 'Сома, ₸',
  'rules.action.percentValue': 'Пайыз',
  'rules.action.factor': 'Көбейткіш',
  'rules.action.expires': 'Бонустың жарамдылық мерзімі, күн',
  'tab.referrals': 'Шақырулар',
  'rules.action.burn': 'Бонуспен төлеу (есептен шығару ережесі)',
  'rules.action.burnShare': 'Чектің қандай үлесін бонуспен төлеуге болады, %',
  'rules.action.burnRate': '1 бонус неше теңге тұрады',
  'rules.action.burnMin': 'Шотта кемінде осынша болғанда жұмсау',
  'rules.action.burnHint':
    'Есептен шығару ережесі бонус есептемейді — ол кассаға бонуспен төлем қабылдауға рұқсат береді. Шартқа сай келетін басымдығы бірінші ереже әрекет етеді; мұндай ереже болмаса, касса бонус қабылдамайды.',
  'rules.action.describeBurn': 'Касса чектің {share} % дейін бонуспен қабылдайды, 1 бонус = {rate} ₸',
  'ref.policy.title': 'Рефералдық бағдарлама шарттары',
  'ref.policy.hint':
    'Шақырылған клиент бірінші сапарын шектен кем емес сомаға төлегенде бонус өзі келеді. Өзін-өзі шақыру және бұрынғы клиенттер қабылданбайды.',
  'ref.policy.enabled': 'Бағдарлама қосулы',
  'ref.policy.referrer': 'Шақырушыға бонус',
  'ref.policy.invitee': 'Шақырылғанға сәлемдесу бонусы',
  'ref.policy.minOrder': 'Бірінші тапсырыс кемінде',
  'ref.policy.expires': 'Бонустардың жарамдылық мерзімі, күн',
  'ref.policy.expiresHint': 'Бос — мерзімсіз',
  'ref.policy.save': 'Шарттарды сақтау',
  'ref.policy.saved': 'Шарттар сақталды',
  'ref.policy.readonly': 'Шарттарды маркетолог өзгертеді',
  'ref.list.title': 'Кім кімді шақырды',
  'ref.list.hint':
    'Арна — код қайдан келді: касса, планшет, әкімшілік, сілтеме немесе бұрынғы жүйеден көшіру.',
  'ref.list.allSources': 'Барлық арналар',
  'ref.list.date': 'Қашан',
  'ref.list.referrer': 'Шақырды',
  'ref.list.invitee': 'Шақырылған',
  'ref.list.source': 'Арна',
  'ref.list.status': 'Күйі',
  'ref.list.reward': 'Бонус',
  'ref.list.empty': 'Әзірге шақырулар жоқ',
  'ref.list.emptyHint':
    'Шақыру коды әр клиентте бар — оны «Клиент» қосымша бетіндегі клиент картасынан көруге болады.',
  'ref.source.pos': 'Касса',
  'ref.source.tablet': 'Планшет',
  'ref.source.admin': 'Әкімшілік',
  'ref.source.link': 'Сілтеме',
  'ref.source.import': 'Көшіру',
  'ref.status.pending': 'Бірінші сапарды күтуде',
  'ref.status.rewarded': 'Бонус есептелді',
  'ref.status.rejected': 'Қабылданбады',
  'ref.card.title': 'Шақырулар',
  'ref.card.code': 'Клиенттің шақыру коды',
  'ref.card.invitedBy': 'Шақырған',
  'ref.card.none': 'Шақырушы көрсетілмеген',
  'ref.card.stats': 'Шақырған клиенттер: {count}, бонуспен: {rewarded}, алынғаны {amount}',
  'ref.card.attachCode': 'Шақырушының коды',
  'ref.card.attach': 'Шақырушыны жазу',
  'ref.card.attached': 'Шақырушы жазылды',
  'rules.preview': 'Алдын ала қарау',
  'rules.preview.from': 'Бастап',
  'rules.preview.to': 'Дейін',
  'rules.preview.run': 'Есептеу',
  'rules.preview.hint': 'Өткен кезеңдегі есеп. Тізілімге ештеңе жазылмайды.',
  'rules.preview.orders': 'Қамтылған тапсырыс',
  'rules.preview.customers': 'Қамтылған клиент',
  'rules.preview.delta': 'Қосымша есептелер еді',
  'rules.preview.scanned': 'Қаралған тапсырыс',
  'rules.preview.truncated': 'Кезеңнің бір бөлігі көрсетілді: тапсырыс тым көп',
  'rules.history': 'Өзгерістер журналы',
  'rules.versions': 'Ереже нұсқалары',
  'account.title': 'Клиент шоты',
  'account.search': 'Клиент',
  'account.searchHint': 'Телефон немесе көлік нөмірі бойынша табыңыз',
  'account.none': 'Бонустық шот әзірге жоқ',
  'account.noneHint':
    'Шот алғашқы есептеумен ашылады. Қолмен есептеу клиенттің алғашқы төленген тапсырысынан кейін мүмкін.',
  'account.load': 'Ашу',
  'account.reload': 'Жаңарту',
  'account.ledgerBalance': 'Тізілім бойынша баланс',
  'account.materialized': 'Материалданған мән',
  'account.drift': 'Алшақтық',
  'account.entries': 'Операциялар тізілімі',
  'account.direction': 'Бағыты',
  'account.amount': 'Сома',
  'account.reason': 'Негіздеме',
  'account.rule': 'Ереже',
  'account.date': 'Күні',
  'account.credit': 'Есептеу',
  'account.debit': 'Есептен шығару',
  'account.more': 'Тағы көрсету',
  'adjust.title': 'Қолмен түзету',
  'adjust.reason': 'Негіздеме',
  'adjust.comment': 'Түсініктеме',
  'adjust.submit': 'Өткізу',
  'adjust.done': 'Түзету өткізілді',
  'module.subtitle': 'Есептеу ережелері, клиент шоттары, деңгейлер және тізілім салыстыруы',
  'tiers.title': 'Бағдарлама деңгейлері',
  'tiers.code': 'Коды',
  'tiers.name': 'Атауы',
  'tiers.condition': 'Кіру шарты',
  'tiers.order': 'Реті',
  'tiers.recalculate': 'Деңгейлерді қайта есептеу',
  'tiers.recalculated': 'Тексерілген клиент: {checked}, ауысу: {changed}',
  'tiers.empty': 'Деңгейлер енгізілмеген',
  'tiers.emptyReason':
    'Төмендегі форманы толтырып, бірінші деңгейді енгізіңіз: коды, атауы және кіру шарты.',
  'tiers.hint': 'Рет үлкендігін белгілейді: сан неғұрлым үлкен болса, деңгей соғұрлым жоғары.',
  'tiers.newTitle': 'Жаңа деңгей',
  'tiers.editTitle': '{code} деңгейін өңдеу',
  'tiers.edit': 'Өңдеу',
  'tiers.create': 'Деңгей енгізу',
  'tiers.save': 'Деңгейді сақтау',
  'tiers.created': 'Деңгей енгізілді',
  'tiers.updated': 'Деңгей жаңартылды',
  'tiers.codeHint': 'Латынша, мысалы silver немесе gold. Кодты кейін өзгертуге болмайды.',
  'tiers.orderHint': 'Үлкенірек — жоғарырақ деңгей',
  'tiers.conditionTitle': 'Кіру шарты',
  'tiers.conditionHint':
    'Бір шарт жеткілікті. Кезең берілсе, шарт соңғы N күн бойынша есептеледі; кезеңсіз — бүкіл уақыт бойынша.',
  'tiers.conditionRequired': 'Кемінде бір кіру шартын беріңіз, әйтпесе деңгей ешкімге тимейді',
  'tiers.minAccrued': 'Есептелген бонус, кемінде',
  'tiers.minSpend': 'Төленген, кемінде',
  'tiers.minVisits': 'Келу саны, кемінде',
  'tiers.periodDays': 'Кезең, күн',
  'tiers.periodHint': 'Бос — бүкіл уақыт',
  'tiers.cond.accrued': '{value} бастап есептелген',
  'tiers.cond.spend': '{value} бастап төленген',
  'tiers.cond.visits': '{value} бастап келу',
  'tiers.cond.window': '{days} күн ішінде',
  'tiers.cond.lifetime': 'бүкіл уақыт',
  'tiers.cond.none': 'шарт берілмеген',
  'recon.title': 'Алшақтықтар туралы есеп',
  'recon.run': 'Салыстыруды бастау',
  'recon.empty': 'Алшақтық жоқ',
  'recon.incident': 'Бос емес есеп — бұл оқиға',
  'recon.checked': 'Тексерілген шот',
  'recon.findings': 'Алшақтық',
  'recon.customer': 'Клиент',
  'recon.materialized': 'Болды',
  'recon.ledger': 'Тізілім',
  'recon.delta': 'Айырма',
  'recon.repaired': 'Түзетілді',
  'recon.never': 'Салыстыру әлі жүргізілмеген',
  'common.loading': 'Жүктелуде…',
  'common.cancel': 'Болдырмау',
  'common.yes': 'Иә',
  'common.no': 'Жоқ',
};

export type LoyaltyKey = keyof typeof RU;
export type LoyaltyTranslate = (
  key: LoyaltyKey,
  params?: Record<string, string | number>,
) => string;

const DICTIONARIES: Record<LoyaltyLocale, Record<LoyaltyKey, string>> = { ru: RU, kk: KK };

export function makeLoyaltyT(locale: LoyaltyLocale): LoyaltyTranslate {
  const dict = DICTIONARIES[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
